var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('guide-menu'),_c('notification-menu'),_c('profile-menu',{attrs:{"class-name":_vm.active}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }